import React, { useState, memo } from 'react';
import { FontFamilyTokens, IconSizeTokens, IconTokens, TypographyTypeDLS, ColorTokens, } from '@voltmoney/schema';
import { View, Text, Pressable, ToastAndroid, Clipboard, Platform, Alert, Image } from 'react-native';
import Icon from '../icon/Icon';
import Typography from '../typography/Typography';
const RepaymentBankTransfer = ({ userName, bankName, bankImage, bankIfscCode, bankAccountNumber, beneficiaryName, branchName, interestBankName, interestBankImage, interestAccountNumber, interestBeneficiaryName, interestAmount, interestIfscCode, interestBranchName, outStandingAmount }) => {
    const [showInterestDetails, setShowInterestDetails] = useState(true);
    const [loading, setLoading] = useState(false);
    const obj = {
        0: showInterestDetails ? interestAccountNumber : bankAccountNumber,
        1: showInterestDetails ? interestIfscCode : bankIfscCode,
        2: showInterestDetails ? interestBeneficiaryName : beneficiaryName,
        3: showInterestDetails ? interestBranchName : branchName,
    };
    const [copyButtons, setCopyButtons] = useState(['Copy', 'Copy', 'Copy', 'Copy']);
    const copyToClipBoard = (index) => {
        Clipboard.setString(obj[index]);
        setCopyButtons((prevState) => {
            return prevState.map((el, i) => {
                if (index === i) {
                    return 'Copied';
                }
                return el;
            });
        });
        setTimeout(() => {
            setCopyButtons((prevState) => {
                return prevState.map((el, i) => {
                    if (index === i) {
                        return 'Copy';
                    }
                    return el;
                });
            });
        }, 4000);
        if (Platform.OS === 'android') {
            ToastAndroid.show("Copied to clipboard!", ToastAndroid.SHORT);
        }
        else {
            Alert.alert("Copied to clipboard!");
        }
    };
    const toggle = () => {
        setLoading(true);
        setTimeout(() => {
            setShowInterestDetails(!showInterestDetails);
            setLoading(false);
        }, 100);
    };
    return (React.createElement(View, null,
        React.createElement(View, { style: {
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                marginVertical: 24,
            } },
            React.createElement(View, { style: {
                    flex: 1,
                    height: 1,
                    backgroundColor: '#E4E7EC',
                } }),
            React.createElement(Text, { style: {
                    paddingHorizontal: 12,
                    color: '#1D2939',
                    fontSize: 16,
                } }, "OR"),
            React.createElement(View, { style: {
                    flex: 1,
                    height: 1,
                    backgroundColor: '#E4E7EC',
                } })),
        React.createElement(Text, { style: {
                lineHeight: 24,
                fontSize: 16,
                marginBottom: 4,
                color: '#1D2939',
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '700',
            } }, "Repay via Bank transfer"),
        React.createElement(View, { style: { flexDirection: 'row', marginVertical: 16 } },
            React.createElement(Pressable, { onPress: toggle, style: { flex: 1, borderColor: '#1434CB', borderBottomWidth: showInterestDetails ? 1 : 0 } },
                React.createElement(Text, { style: {
                        lineHeight: 20,
                        fontFamily: FontFamilyTokens.Inter,
                        marginVertical: 8,
                        color: showInterestDetails ? '#1434CB' : '#667085',
                        textAlign: 'center',
                        fontWeight: '700',
                    } }, "Repay interest")),
            React.createElement(Pressable, { onPress: toggle, style: { flex: 1, borderColor: '#1434CB', borderBottomWidth: !showInterestDetails ? 1 : 0 } },
                React.createElement(Text, { style: {
                        lineHeight: 20,
                        fontFamily: FontFamilyTokens.Inter,
                        marginVertical: 8,
                        color: !showInterestDetails ? '#1434CB' : '#667085',
                        textAlign: 'center',
                        fontWeight: '700',
                    } }, "Repay principal"))),
        loading ? React.createElement(React.Fragment, null) : React.createElement(React.Fragment, null,
            React.createElement(View, { style: { flexDirection: 'row', display: 'flex' } },
                React.createElement(View, { style: { backgroundColor: '#E4E7EC', width: 28, height: 28, borderRadius: 25, alignItems: 'center', justifyContent: 'center', marginRight: 12 } },
                    React.createElement(View, { style: { backgroundColor: '#98A2B3', width: 24, height: 24, borderRadius: 25, alignItems: 'center', justifyContent: 'center' } },
                        React.createElement(Text, { style: { color: '#FFF', lineHeight: 18, fontWeight: '600', fontSize: 12 } }, "1")),
                    React.createElement(View, { style: { height: 100, backgroundColor: '#E4E7EC', width: 2, position: 'absolute', left: 13, top: 28, zIndex: -1 } })),
                React.createElement(View, { style: { flex: 1 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `Check your bank account`, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(View, { style: { flexDirection: 'row', flexWrap: 'wrap', marginBottom: 16 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Bank account should be in the name of`, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: ` ` + userName, color: ColorTokens.Grey_Charcoal })),
                    React.createElement(View, { style: { backgroundColor: '#FDF7E7', padding: 12, borderRadius: 8, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', flex: 1 } },
                        React.createElement(View, { style: { marginRight: 8 } },
                            React.createElement(Icon, { name: IconTokens.SystemWarning, size: IconSizeTokens.XL })),
                        React.createElement(View, { style: { flexDirection: 'row', flex: 1, flexWrap: 'wrap' } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Transactions made via other bank account can result in accounting delays or rejections`, color: ColorTokens.Grey_Night }))))),
            React.createElement(View, { style: { flexDirection: 'row', marginTop: 24 } },
                React.createElement(View, { style: { backgroundColor: '#E4E7EC', width: 28, height: 28, borderRadius: 25, alignItems: 'center', justifyContent: 'center', marginRight: 12 } },
                    React.createElement(View, { style: { backgroundColor: '#98A2B3', width: 24, height: 24, borderRadius: 25, alignItems: 'center', justifyContent: 'center' } },
                        React.createElement(Text, { style: { color: '#FFF', lineHeight: 18, fontWeight: '600', fontSize: 12 } }, "2")),
                    React.createElement(View, { style: { height: 100, backgroundColor: '#E4E7EC', width: 2, position: 'absolute', left: 13, bottom: 0, zIndex: -1 } }),
                    React.createElement(View, { style: { height: 150, backgroundColor: '#E4E7EC', width: 2, position: 'absolute', left: 13, top: 10, zIndex: -1 } })),
                React.createElement(View, { style: { flex: 1 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `Add beneficiary`, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(View, { style: { flexDirection: 'row', flexWrap: 'wrap', marginBottom: 16 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Add beneficiary via net banking, on UPI app or pay at your bank branch`, color: ColorTokens.Grey_Charcoal })),
                    React.createElement(View, { style: {
                            borderColor: '#E4E7EC',
                            borderRadius: 6,
                            borderWidth: 1,
                            padding: 16,
                        } },
                        React.createElement(Text, { style: {
                                color: '#667085',
                                lineHeight: 18,
                                fontWeight: '700',
                                fontSize: 12,
                                fontFamily: FontFamilyTokens.Inter,
                                marginBottom: 2
                            } }, showInterestDetails ? 'Amount due' : 'Outstanding amount'),
                        React.createElement(Text, { style: {
                                color: '#1D2939',
                                fontWeight: '700',
                                lineHeight: 24,
                                fontFamily: FontFamilyTokens.Inter,
                                fontSize: 16,
                            } },
                            "\u20B9",
                            showInterestDetails ? interestAmount : outStandingAmount),
                        React.createElement(View, { style: { width: '100%', height: 1, backgroundColor: '#F1F3F5', marginVertical: 12 } }),
                        React.createElement(View, { style: {
                                flexDirection: 'row'
                            } },
                            React.createElement(Image, { source: {
                                    uri: showInterestDetails ? interestBankImage : bankImage,
                                }, style: { backgroundColor: '#F1F3F5', width: 24, height: 24, marginRight: 8, borderRadius: 25 } }),
                            React.createElement(Text, { style: {
                                    color: '#1D2939',
                                    fontWeight: '600',
                                    lineHeight: 24,
                                    fontFamily: FontFamilyTokens.Inter,
                                    fontSize: 12,
                                } }, showInterestDetails ? interestBankName : bankName)),
                        React.createElement(View, { style: { width: '100%', height: 1, backgroundColor: '#F1F3F5', marginVertical: 12 } }),
                        React.createElement(Text, { style: {
                                color: '#667085',
                                fontWeight: '400',
                                lineHeight: 18,
                                fontFamily: FontFamilyTokens.Inter,
                                fontSize: 12,
                            } }, "Account number"),
                        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                            React.createElement(Text, { style: {
                                    color: '#1D2939',
                                    fontWeight: '500',
                                    lineHeight: 20,
                                    fontFamily: FontFamilyTokens.Inter,
                                    fontSize: 14,
                                } }, obj[0]),
                            React.createElement(Pressable, { style: { flexDirection: 'row', alignItems: 'center' }, onPress: () => copyToClipBoard(0) },
                                React.createElement(Icon, { name: IconTokens.SYSTEM_COPY_DLS, size: IconSizeTokens.SM }),
                                React.createElement(Text, { style: {
                                        color: '#1434CB',
                                        fontSize: 12,
                                        fontFamily: FontFamilyTokens.Inter,
                                        fontWeight: '500',
                                        lineHeight: 18
                                    } }, copyButtons[0]))),
                        React.createElement(View, { style: { width: '100%', height: 1, backgroundColor: '#F1F3F5', marginVertical: 12 } }),
                        React.createElement(Text, { style: {
                                color: '#667085',
                                fontWeight: '400',
                                lineHeight: 18,
                                fontFamily: FontFamilyTokens.Inter,
                                fontSize: 12,
                            } }, "Beneficiary name"),
                        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                            React.createElement(Text, { style: {
                                    color: '#1D2939',
                                    fontWeight: '500',
                                    lineHeight: 20,
                                    fontFamily: FontFamilyTokens.Inter,
                                    fontSize: 14,
                                } }, obj[2]),
                            React.createElement(Pressable, { style: { flexDirection: 'row', alignItems: 'center' }, onPress: () => copyToClipBoard(1) },
                                React.createElement(Icon, { name: IconTokens.SYSTEM_COPY_DLS, size: IconSizeTokens.SM }),
                                React.createElement(Text, { style: {
                                        color: '#1434CB',
                                        fontSize: 12,
                                        fontFamily: FontFamilyTokens.Inter,
                                        fontWeight: '500',
                                        lineHeight: 18
                                    } }, copyButtons[1]))),
                        React.createElement(View, { style: { width: '100%', height: 1, backgroundColor: '#F1F3F5', marginVertical: 12 } }),
                        React.createElement(Text, { style: {
                                color: '#667085',
                                fontWeight: '400',
                                lineHeight: 18,
                                fontFamily: FontFamilyTokens.Inter,
                                fontSize: 12,
                            } }, "IFSC"),
                        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                            React.createElement(Text, { style: {
                                    color: '#1D2939',
                                    fontWeight: '500',
                                    lineHeight: 20,
                                    fontFamily: FontFamilyTokens.Inter,
                                    fontSize: 14,
                                } }, obj[1]),
                            React.createElement(Pressable, { style: { flexDirection: 'row', alignItems: 'center' }, onPress: () => copyToClipBoard(2) },
                                React.createElement(Icon, { name: IconTokens.SYSTEM_COPY_DLS, size: IconSizeTokens.SM }),
                                React.createElement(Text, { style: {
                                        color: '#1434CB',
                                        fontSize: 12,
                                        fontFamily: FontFamilyTokens.Inter,
                                        fontWeight: '500',
                                        lineHeight: 18
                                    } }, copyButtons[2]))),
                        React.createElement(View, { style: { width: '100%', height: 1, backgroundColor: '#F1F3F5', marginVertical: 12 } }),
                        React.createElement(Text, { style: {
                                color: '#667085',
                                fontWeight: '400',
                                fontFamily: FontFamilyTokens.Inter,
                                lineHeight: 18,
                                fontSize: 12,
                            } }, "Branch name"),
                        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                            React.createElement(Text, { style: {
                                    color: '#1D2939',
                                    fontWeight: '500',
                                    lineHeight: 20,
                                    fontFamily: FontFamilyTokens.Inter,
                                    fontSize: 14,
                                } }, showInterestDetails ? interestBranchName : branchName),
                            React.createElement(Pressable, { style: { flexDirection: 'row', alignItems: 'center' }, onPress: () => copyToClipBoard(3) },
                                React.createElement(Icon, { name: IconTokens.SYSTEM_COPY_DLS, size: IconSizeTokens.SM }),
                                React.createElement(Text, { style: {
                                        color: '#1434CB',
                                        fontSize: 12,
                                        fontFamily: FontFamilyTokens.Inter,
                                        fontWeight: '500',
                                        lineHeight: 18
                                    } }, [copyButtons[3]])))))),
            React.createElement(View, { style: { flexDirection: 'row', marginVertical: 24 } },
                React.createElement(View, { style: { backgroundColor: '#E4E7EC', width: 28, height: 28, borderRadius: 25, alignItems: 'center', justifyContent: 'center', marginRight: 12 } },
                    React.createElement(View, { style: { backgroundColor: '#98A2B3', width: 24, height: 24, borderRadius: 25, alignItems: 'center', justifyContent: 'center' } },
                        React.createElement(Text, { style: { color: '#FFF', lineHeight: 18, fontWeight: '600', fontSize: 12 } }, "3")),
                    React.createElement(View, { style: { height: 350, backgroundColor: '#E4E7EC', width: 2, position: 'absolute', left: 13, bottom: 0, zIndex: -1 } })),
                React.createElement(View, { style: { flex: 1 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `The amount will get reflected in your loan account within 1-2 business hours. Check the transactions tab to track progress`, color: ColorTokens.Grey_Charcoal }))))));
};
export default memo(RepaymentBankTransfer);
